<template>
  <div>
    <div class="card card-custom">
      <div class="card-header">
        <div class="d-flex justify-content-between align-items-center w-100">
          <button onclick="javascript:location.href='../UIC/CDCShareHolderImport'"
                  type="button" class="btn btn-sm btn-primary">
            <i class="fa fa-plus"></i> Import New List
          </button>

          <button id="btnDeleteSelected"
                  class="btn btn-danger btn-sm"
                  style="display:none"
                  @click="confirmDelete(selectedIds)">
            <i class="fa fa-trash"></i>
            Delete Selected (<span id="selCount">0</span>)
          </button>
        </div>
      </div>

      <div class="card-body">
        <table class="table table-sm table-bordered" id="myTable">
          <thead class="bg-custom">
            <tr>
              <th width="2%"><input type="checkbox" id="chkAll"></th>
              <th width="2%">Sr.</th>
              <th width="5%">Folio No.</th>
              <th width="13%">Name</th>
              <th width="24%">Address</th>
              <th width="6%">Share Held</th>
              <th width="10%">CNIC No</th>
              <th width="10%">Mobile No.</th>
              <th width="10%">Email Address</th>
              <th width="5%">CDC Y/N</th>
              <th width="6%">As on Date</th>
              <th width="6%">Insert Date</th>
              <th width="5%">Action</th>
            </tr>
          </thead>
          <tbody id="myTableBody">
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    data() {
      return {
        list: [],
        selectedIds: [],
      }
    },
    created() {
      this.pageload();
    },
    methods: {
      pageload() {
        var vm = this;
        startReq();
        axios.get("/api/UICApi/pageLoadCDCShareHolderList")
          .then(function (res) {
            endReq();
            vm.list = res.data.list;
            vm.selectedIds = [];
            vm.renderTable();
          })
          .catch((error) => {
            endReq();
            console.log(error);
          });
      },

      renderTable() {
        var vm = this;

        if ($.fn.DataTable.isDataTable("#myTable")) {
          $("#myTable").DataTable().destroy();
        }

        var rows = '';
        vm.list.forEach(function (item, ind) {
          rows += `
          <tr>
            <td><input type="checkbox" class="row-chk" data-id="${item.SHAREHOLDER_ID}"></td>
            <td>${ind + 1}</td>
            <td>${item.FOLIO_NO || ''}</td>
            <td>${item.NAME || ''}</td>
            <td>${item.ADDRESS || ''}</td>
            <td style="text-align:right">${vm.formatNumber(item.SHARE_HELD)}</td>
            <td>${item.CNIC_NO || ''}</td>
            <td>${item.MOBILE_NO || ''}</td>
            <td>${item.EMAIL_ADDRESS || ''}</td>
            <td>${item.CDC_YN || ''}</td>
            <td>${vm.formatDate(item.AS_ON_DATE)}</td>
            <td>${vm.formatDate(item.INSERT_DATE)}</td>
            <td>
              <button class="btn btn-danger btn-sm btn-del" data-id="${item.SHAREHOLDER_ID}">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>`;
        });

        $("#myTableBody").html(rows);

        $("#myTable").DataTable({
          pageLength: 10,
          lengthMenu: [10, 25, 50, 100],
          ordering: true,
          searching: true,
          columnDefs: [{ orderable: false, targets: [0, 12] }]
        });

        $("#chkAll").prop("checked", false);
        $("#btnDeleteSelected").hide();
        $("#selCount").text("0");

        vm.bindEvents();
      },

      bindEvents() {
        var vm = this;

        $("#myTable tbody").off("click", ".btn-del")
          .on("click", ".btn-del", function () {
            var id = parseInt($(this).data("id"));
            vm.confirmDelete([id]);
          });

        $("#myTable tbody").off("change", ".row-chk")
          .on("change", ".row-chk", function () {
            var id = parseInt($(this).data("id"));
            if ($(this).is(":checked")) {
              if (!vm.selectedIds.includes(id)) {
                vm.selectedIds = [...vm.selectedIds, id];
              }
            } else {
              vm.selectedIds = vm.selectedIds.filter(x => x !== id);
              $("#chkAll").prop("checked", false);
            }
            vm.updateDeleteButton();
          });

        $("#chkAll").off("change").on("change", function () {
          var checked = $(this).is(":checked");
          var allIds = [];
          $("#myTable").DataTable().rows().nodes().each(function (row) {
            var chk = $(row).find(".row-chk");
            chk.prop("checked", checked);
            var id = parseInt(chk.data("id"));
            if (checked) allIds.push(id);
          });
          vm.selectedIds = checked ? allIds : [];
          vm.updateDeleteButton();
        });
      },

      updateDeleteButton() {
        var count = this.selectedIds.length;
        $("#selCount").text(count);
        if (count > 0) {
          $("#btnDeleteSelected").show();
        } else {
          $("#btnDeleteSelected").hide();
        }
      },

      confirmDelete(ids) {
        if (!ids || ids.length === 0) return;
        var vm = this;
        var msg = ids.length === 1
          ? "Are you sure you want to delete this record?"
          : `Are you sure you want to delete ${ids.length} selected record(s)?`;

        Swal.fire({
          title: 'Are you sure?',
          text: msg,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#6c757d',
          confirmButtonText: 'Yes, Delete!',
          cancelButtonText: 'Cancel'
        }).then((result) => {
          if (result.isConfirmed) {
            vm.deleteRecords(ids);
          }
        });
      },

      deleteRecords(ids) {
        var vm = this;
        startReq();
        axios.post("/api/UICApi/deleteCDCShareHolder", { ids: ids })
          .then(res => {
            endReq();
            if (res.data.status) {
              Swal.fire({
                icon: 'success',
                title: 'Deleted!',
                text: res.data.msg,
                timer: 1500,
                showConfirmButton: false
              });
              vm.selectedIds = [];
              vm.pageload();
            } else {
              Swal.fire({ icon: 'error', title: 'Error', text: res.data.msg });
            }
          })
          .catch(err => {
            endReq();
            console.log(err);
          });
      },

      formatDate(date) {
        return date ? new Date(date).toISOString().split('T')[0] : '';
      },
      formatNumber(num) {
        return num ? Math.round(num).toLocaleString() : "0";
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/ims/CDCShareHolderList.vue